function isValidDate(d) {
	return d instanceof Date && !isNaN(d);
}

function Clock() {
	this.timeDiff;
	this.timer;
	this.timeTarget;
	this.dateTarget;
	this.analogTarget;
	this.countdownTarget;
	this.countdownCallback;
	this.endTime;

	this.setClock = function (dateString, timeTargetId, dateTargetId, analogTargetId) {
		var d = new Date(dateString * 1);
		if (!isValidDate(d)) {
			//обратная совместимость
			eval("var d = new Date(" + dateString + ");");
		}
//		d = new Date(d.toLocaleString("en-US", {timeZone: "Europe/Moscow"}));
		d.setTime(d.getTime() + ((d.getTimezoneOffset()+180)*60000));
		var n = new Date();
		this.timeDiff = d.getTime() - n.getTime();
		if (timeTargetId)
			this.runClockTimer(timeTargetId, dateTargetId, analogTargetId);
	};

	this.now = function () {
		var d = new Date();
		d.setMilliseconds(d.getMilliseconds() + this.timeDiff);
		return d;
	};

	this.runClockTimer = function (timeTargetId, dateTargetId, analogTargetId) {
		this.timeTarget = document.getElementById(timeTargetId);
		this.dateTarget = document.getElementById(dateTargetId);
		this.analogTarget = document.getElementById(analogTargetId);
		this.timerTick();
	};

	this.timerTick = function () {
		if (clock.timer)
			clearTimeout(clock.timer);
		if (clock.timeTarget && clock.timeDiff)
			clock.timeTarget.innerHTML = clock.now().format("HH:MM");
		if (clock.dateTarget && clock.timeDiff)
			clock.dateTarget.innerHTML = clock.now().format("dd.mm.yyyy");
		if (clock.countdownTarget && clock.endTime) {
			var n = clock.now();
			var diffsec = (clock.endTime.getTime() - n.getTime()) / 1000;
			clock.countdownTarget.innerHTML = clock.secToHms(diffsec);
			if (diffsec <= 0) {
				clock.countdownTarget = null;
				clock.endTime = null;
				if (clock.countdownCallback)
					clock.countdownCallback();
			}

		}

		clock.timer = setTimeout(clock.timerTick, 1000);

	};

	this.countdownTimer = function (timeTargetId, counterTargetId, endTimeString, callback) {
		var d = new Date(endTimeString * 1);
		if (!isValidDate(d)) {
			//обратная совместимость
			eval("var d = new Date(" + endTimeString + ");");
		}
//		d = new Date(d.toLocaleString("en-US", {timeZone: "Europe/Moscow"}));
		d.setTime(d.getTime() + ((d.getTimezoneOffset()+180)*60000));
		this.endTime = d;
		this.countdownTarget = document.getElementById(counterTargetId);
		if (timeTargetId) {
			var timeTarget = document.getElementById(timeTargetId);
			timeTarget.innerHTML = this.endTime.format("dd.mm.yyyy HH:MM:ss");
		}
		this.countdownCallback = callback;
		this.timerTick();
	};

	this.secToHms = function (d) {
		d = Number(d);
		if (d < 0)
			return "00:00:00";
		var h = Math.floor(d / 3600);
		var m = Math.floor(d % 3600 / 60);
		var s = Math.floor(d % 3600 % 60);
		return this.add0(h) + ":" + this.add0(m) + ":" + this.add0(s);
	};

	this.add0 = function (x) {
		return (x < 10 ? "0" + x : x);
	};

}

var clock = new Clock();